function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { sdkLogger } from '../../logger';
export var DeferredEventQueue = /*#__PURE__*/ function() {
    "use strict";
    function DeferredEventQueue(deferMs) {
        _class_call_check(this, DeferredEventQueue);
        _define_property(this, "deferMs", void 0);
        _define_property(this, "queue", void 0);
        this.deferMs = deferMs;
        this.queue = null;
        this.queue = [];
    }
    _create_class(DeferredEventQueue, [
        {
            key: "push",
            value: function push(fn) {
                var _this = this;
                /**
         * In the case where we don't want to defer addons, we will execute the function synchronously.
         * Also should take into account events raised after the queue is destroyed. In this scenario just execute the function
         */ if (!this.deferMs || !this.queue) {
                    fn();
                    return;
                }
                var event = {
                    function: fn,
                    timeout: undefined
                };
                var timeout = setTimeout(function() {
                    var _this_queue;
                    (_this_queue = _this.queue) === null || _this_queue === void 0 ? void 0 : _this_queue.shift();
                    fn();
                }, this.deferMs);
                event.timeout = timeout;
                this.queue.push(event);
            }
        },
        {
            key: "executePending",
            value: function executePending() {
                var _this_queue;
                (_this_queue = this.queue) === null || _this_queue === void 0 ? void 0 : _this_queue.forEach(function(event) {
                    clearTimeout(event.timeout);
                    try {
                        event.function();
                    } catch (e) {
                        sdkLogger.withContext('Event Queue').error(e);
                    }
                });
                this.queue = null;
            }
        }
    ]);
    return DeferredEventQueue;
}();

//# sourceMappingURL=deferred-event-queue.js.map